module.exports = __webpack_public_path__ + "static/media/landing-image2.892c5700.png";